// extracted by mini-css-extract-plugin
export default {"cls1":"rKofGJkCO4JSeJwNM0Kt","cls2":"lVTX9BRdzNP9cOiP7qHW rKofGJkCO4JSeJwNM0Kt"};